export default __webpack_public_path__ + "static/media/crossChain.43828217.svg";